import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  getSupliers,
  getProducts,
  GetById,
} from "adminApi/PurchaseItemApi/PurchaseItem";

import Spinner from "Common/Globle/Spinner";
import fields from "../json/PurchaseItemFeilds.json";

import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import { validateForm } from "utils/validation";
import { PurchaseItemRules } from "validation/ValidationRules";

import EditPurchaseItemForm from "./Componates/EditPurchaseItemForm";

const EditPurchaseItem = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { formdata } = fields;

  const initialValues = formdata.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  const { values, errors, handleChange, setErrors, setValues } = useFormChange(
    initialValues,
    PurchaseItemRules
  );

  // Track initial fetch loading state so spinner shows while data loads
  const [loadingFetch, setLoadingFetch] = useState(false);

  // Load Purchase By ID — only map expected flat fields to avoid polluting form state
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      setLoadingFetch(true);
      try {
        const res = await GetById(id);
        const payload = res?.data?.data || {};

        // Map only the fields the form expects — keep items separate for the table
        setValues((prev) => ({
          ...prev,
          supplier_id: payload.supplier_id ?? "",
          invoice_id: payload.invoice_id ?? "",
          purchase_date: payload.purchase_date?.split("T")[0] ?? "",
          purchase_expiry_date: payload.purchase_expiry_date?.split("T")[0] ?? "",
          details: payload.details ?? "",
          grand_total: payload.total_price ?? "",
          items: payload.items || [],
        }));
      } catch (error) {
        console.error("Error fetching purchase:", error);
      } finally {
        setLoadingFetch(false);
      }
    };

    fetchData();
  }, [id]);

  // Load products & suppliers
  const { data: productOptions, loading: loadingProducts } =
    useFetchAllData(getProducts);

  const { data: supplierOptions, loading: loadingSuppliers } =
    useFetchAllData(getSupliers);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => await Update({ id, data: formValues }),
    (vals) => {
      const err = validateForm(vals, PurchaseItemRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Purchase Item Updated Successfully!"
  );

  const JsonData = formdata.filter((f) => f.name !== "grand_total");

  return (
    <>
      {(loadingFetch || loadingSubmit || loadingProducts || loadingSuppliers) && (
        <Spinner isSpinner={true} />
      )}

      <EditPurchaseItemForm
        fields={JsonData}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(data) => handleSubmit(null, data)}
        loading={loadingSubmit}
        supplierOptions={supplierOptions}
        productOptions={productOptions}
        title="Update Purchase Item"
      />
    </>
  );
};

export default EditPurchaseItem;
